import React from 'react'
import { IconButton } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import { Close } from '@mui/icons-material'
import useKlaro from 'hooks/useKlaro'

import AppRoutes from './Routes'

const App: React.FC = () => {
  useKlaro()

  const notistackRef = React.createRef<any>()
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key)
  }

  return (
    <SnackbarProvider
      hideIconVariant={true}
      ref={notistackRef}
      maxSnack={1}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      action={(key) => (
        <IconButton
          size="small"
          sx={{ color: 'common.white' }}
          onClick={onClickDismiss(key)}
        >
          <Close fontSize="small" />
        </IconButton>
      )}
    >
      <AppRoutes />
    </SnackbarProvider>
  )
}

export default App
